const getVariantIndexFromKey = (key) => {
  if (!key) {
    return null;
  }
  const match = key.match(/legal-content-variant(\d+)\//);
  return match ? Number(match[1]) : null;
};

const applyLegalContentVariantsRule = (data) => {
  const result = { ...data };

  const variantNameEntries = Object.entries(result).filter(([key]) =>
    /^codes-legal\/legal-content-variant\d+\/variant-name$/.test(key)
  );

  if (variantNameEntries.length === 0) {
    return result;
  }

  const sorted = variantNameEntries.sort((a, b) => {
    const aIdx = getVariantIndexFromKey(a[0]);
    const bIdx = getVariantIndexFromKey(b[0]);
    return (aIdx || 0) - (bIdx || 0);
  });

  const emptyIndices = [];

  sorted.forEach(([key, value]) => {
    const idx = getVariantIndexFromKey(key);
    if (idx !== null && (!value || !String(value).trim())) {
      emptyIndices.push(idx);
    }
  });

  if (emptyIndices.length === 0) {
    return result;
  }

  const firstEmpty = emptyIndices[0];

  const prefixesToDelete = emptyIndices
    .filter((idx) => idx !== firstEmpty)
    .map((idx) => `codes-legal/legal-content-variant${idx}/`);

  const cleaned = Object.fromEntries(
    Object.entries(result).filter(
      ([key]) => !prefixesToDelete.some((prefix) => key.startsWith(prefix))
    )
  );

  return cleaned;
};

export default applyLegalContentVariantsRule;
